import {SessionRepository} from "@/network/repository/SessionRepository";
import {NetworkUserLoginSuccessResponse} from "@/network/model/NetworkUserLoginSuccessResponse";
import {NetworkError, performGet, performPost} from "@/network/RequestUtils";
import {NetworkUserLoginFailureResponse} from "@/network/model/NetworkUserLoginFailureResponse";
import {NetworkUserLoginQueryIDPsResponse} from "@/network/model/NetworkUserLoginQueryIDPsResponse";

export class DefaultSessionRepository implements SessionRepository {
    async performLogin(
        userId: string,
        password: string,
        securityCode?: number,
        fromURI?: string,
        lang?: string
    ): Promise<NetworkUserLoginSuccessResponse> {
        return await performPost<NetworkUserLoginSuccessResponse>({
            url: "sc/a/UserLogin",
            jsonBodyObj: {
                userId: userId,
                password: password,
                "security-code": securityCode,
                fromURI: fromURI,
                lang: lang,
            },
            showErrorDialog: false, // the caller will handle this
        });
    }

    // Not really sure if this belongs here, but it seems somewhat related
    isSecurityCodeRequired(error: Error): boolean {
        if (error instanceof NetworkError) {
            // Parse the error payload for login
            try {
                const failure = JSON.parse(error.responseText || "") as NetworkUserLoginFailureResponse;
                return failure.securityCodeRequired;
            } catch {
                // Ignore parsing errors here
            }
        }
        return false;
    }

    async queryIDPs(userId: string): Promise<NetworkUserLoginQueryIDPsResponse> {
        return await performGet<NetworkUserLoginQueryIDPsResponse>({
            url: "sc/a/UserLoginQueryIDPs",
            data: {
                userId: userId,
            },
        });
    }
}
